import { InjectionToken } from '@angular/core';
import { SeoConfigurationInterface } from '../interfaces';

/** @deprecated Should be moved to app or utility library */
export const SEO_CONFIGURATION = new InjectionToken<SeoConfigurationInterface>('SeoConfiguration');
